import {
  addAccessTokenToRequests,
  refreshAccessTokenOnResponseError,
} from "@features/authentication";
import {
  collectApiErrors,
  tryConvertErrorResponseIntoQueryApiError,
} from "@features/errors/global-errors";

import {
  apiConfig,
  privateApiAxiosInstance,
  publicApiAxiosInstance,
} from "@shared/api";
import { getClientEnv } from "@shared/libs/runtime-env";

export const initializeNetwork = async () => {
  apiConfig.basePath =
    getClientEnv("VITE_STAND") === "LOCAL" ? "" : getClientEnv("VITE_API_HOST");
  addAccessTokenToRequests(privateApiAxiosInstance);
  refreshAccessTokenOnResponseError(privateApiAxiosInstance);

  tryConvertErrorResponseIntoQueryApiError(publicApiAxiosInstance);
  collectApiErrors(publicApiAxiosInstance);

  tryConvertErrorResponseIntoQueryApiError(privateApiAxiosInstance);
  collectApiErrors(privateApiAxiosInstance);
};
